import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { quantityMsg, t } from '../../../common/i18n/index.js';
import { PRODUCT_DETAILS_CLASS } from '../productDetailsConstants.js';

export interface ProductDetailsQuantityProps {
  quantity: number;
  setQuantity: (amount: number) => void;
  maxValue?: number;
  disabled?: boolean;
}

export const ProductDetailsQuantity = (props: ProductDetailsQuantityProps) => {
  const { quantity, setQuantity, maxValue, disabled = false } = props;

  return (
    <div className={`${PRODUCT_DETAILS_CLASS}-quantity ${dsClass.MARGIN_BOTTOM_3}`}>
      <div className={`${PRODUCT_DETAILS_CLASS}-quantity__amount`}>
        <label
          className={`${dsClass.COLOR_BLUE_800} ${dsClass.TEXT_S} ${dsClass.FONT_WEIGHT_BOLD} ${dsClass.DISPLAY_BLOCK} ${dsClass.MARGIN_BOTTOM_1}`}
        >
          {t.M0W7(quantityMsg)}
        </label>
        <CL.Quantity
          minValue={1}
          maxValue={maxValue || undefined}
          currentValue={quantity}
          onChange={(q: number) => setQuantity(q)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
